<template>
  <el-scrollbar>
    <el-menu
      active-text-color="#1890ff"
      background-color="#f4f8fc"
      class="el-menu-vertical-demo"
      :default-active="$route.path"
      text-color="#62676E"
      unique-opened
      :collapse="isCollapse"
  >
    <template v-for="(item,index) in menuList" :key="index">

      <el-sub-menu v-if="item.children && item.children.length > 0" :index="String(item.id)">
        <template #title>
          <ElIcons v-if="item.css" :name="item.css" size="20"/>
          <ElIcons v-else name="FolderAdd" size="20"/>
          <span :style="{paddingLeft: !isCollapse?'10px':''}">{{item.name}}</span>
          <div class="red-dot" v-if="menuTagList.indexOf(item.id) > -1"></div>
        </template>
        <template v-for="(child, index) in item.children" :key="index">
<!--          <router-link :to="child.url">-->
<!--            <el-menu-item :index="child.url">-->
<!--              <span style="padding-left: 18px;">{{child.name}}</span><ElIcons name="Lock" v-if="child.lockState == 1" :size="12"/>-->
<!--            </el-menu-item>-->
<!--          </router-link>-->
          <div @click="goNext(child.url, child.lockState, child.id)">
            <el-menu-item :index="child.url">
              <span style="padding-left: 18px;">{{child.name}}</span>
              <div class="red-dot" v-if="menuTagList.indexOf(child.id) > -1"></div>
              <ElIcons name="Lock" v-if="child.lockState == 1" :size="12"/>
<!--              <ElIcons name="Lock" v-if="child.unLock" :size="16" @click.stop="lock"/>-->
            </el-menu-item>
          </div>
        </template>
      </el-sub-menu>

<!--      <router-link v-else :to="item.url">-->
<!--        <el-menu-item :index="item.url">-->
<!--          <ElIcons v-if="item.css" :name="item.css" size="20"/>-->
<!--          <ElIcons v-else name="Document" size="20"/>-->
<!--          <template #title>-->
<!--            <span style="padding-left: 10px;">{{item.name}}</span><ElIcons name="Lock" v-if="item.lockState == 1" :size="12"/>-->
<!--          </template>-->
<!--        </el-menu-item>-->
<!--      </router-link>-->

      <div v-else @click="goNext(item.url, item.lockState, item.id)">
        <el-menu-item :index="item.url">
          <ElIcons v-if="item.css" :name="item.css" size="20"/>
          <ElIcons v-else name="Document" size="20"/>
          <template #title>
            <span style="padding-left: 10px;">{{item.name}}</span>
            <div class="red-dot" v-if="menuTagList.indexOf(item.id) > -1"></div>
            <ElIcons name="Lock" v-if="item.lockState == 1" :size="12"/>
<!--            <ElIcons name="Lock" v-if="item.unLock == 1" :size="16" @click.stop="lock"/>-->

          </template>
        </el-menu-item>
      </div>

    </template>
  </el-menu>
  </el-scrollbar>
</template>

<script>

import Dialog from "@/assets/js/dialog";
import Lock from "@/layout/components/Lock";
import { getSysListMenuTag } from "@/api/url";
import { getFormData } from "@/api/api";

export default {
  name: "sidebar",
  data() {
    return {
    //   menuList: JSON.parse(localStorage.getItem('menuList'))
    //   menuTagList: []
    }
  },
  methods: {

    goNext(url, state, id) {
      if(state == 1) {
        Dialog.open({
          title: '',
          component: Lock,
          data: {
            url: url,
            width: '500px',
          },
          confirm: (result) => {
            localStorage.removeItem('menuList')
            this.menuList.map(item => {
              if(item.lockState == 1) {
                item.lockState = 0
                item.unLock = true
              }
              if(item.children && item.children.length > 0) {
                item.children.map(e => {
                  if(e.lockState == 1) {
                    e.lockState = 0
                    e.unLock = true
                  }
                })
              }
            })
            localStorage.setItem('menuList', JSON.stringify(this.menuList))
            this.$router.push({
              path: url,
              query: {menuId: id}
            })
          }
        })

      }else {
        this.$router.push({
          path: url,
          query: {menuId: id}
        })
      }
      // this.$router.push({
      //   path: url,
      //   query: {menuId: id}
      // })
    },

    // lock() {
    //   this.menuList = JSON.parse(localStorage.getItem('menuLockList'))
    // }


    getMenuTag() {
      getFormData(getSysListMenuTag).then(data => {
        let list = data.data
        let tagList = []
        list.map(item => {
          if(item.tagNum > 0) {
            tagList.push(item.menuId)
          }
        })
        this.menuList.map(item => {
          if(item.children && item.children.length > 0) {
            for(let i=0; i<item.children.length; i++) {
              if(tagList.indexOf(item.children[i].id) > -1) {
                tagList.push(item.id)
                break;
              }
            }
          }
        })
        this.$store.commit('UPDATE_MENU_TAG_LIST', tagList)
      })
    }


  },
  computed: {
    menuList() {
      return JSON.parse(localStorage.getItem('menuList'))
    },
    isCollapse() {
      return this.$store.state.sidebar.opened
    },
    menuTagList() {
      return this.$store.state.menuTagList
    }
  },
  mounted() {
    this.getMenuTag()
  }
}
</script>

<style scoped>
.red-dot {
  width: 6px;
  height: 6px;
  background-color: red;
  border-radius: 3px;
  margin-left: 4px;
  margin-top: -8px;
}
</style>
